module.exports = __webpack_public_path__ + "static/media/Parent-Child Image.be3e7821.png";